import { anonymousApiV2, apiV2, errorHandler } from "./index";
import { AUTH_USER, AUTH_ERROR, UNAUTH_USER } from "../constants/ActionTypes";

import SessionHelper from "../components/Helper/SessionHelper";

//= ===============================
// Authentication actions
//= ===============================

export function emailLogin({ email, password }) {
  return async function (dispatch) {
    try {
      // Step 1: Authenticate via APIv2
      const response = await anonymousApiV2.post('/auth/login', {
        username: email,
        password: password,
      });

      // Step 2: Validate and store tokens
      if (!response.data.access_token) {
        throw new Error('Login failed: no access token received');
      }
      SessionHelper.beginLogin(SessionHelper.SESSION_EMAIL);
      SessionHelper.setToken(response.data.access_token);
      if (response.data.refresh_token) {
        SessionHelper.setApiV2RefreshToken(response.data.refresh_token);
      }

      // Step 3: Fetch admin profile with permissions
      const meResponse = await apiV2.get('/admin/me');
      const userData = {
        ...meResponse.data,
        permissions: meResponse.data.permissions || [],
        // Email/password login = local credentials, not federated.
        // The SSO path (Auth/Callback) sets this to true so the
        // Account page can decide whether to lock the email field.
        is_federated: false,
      };

      // Step 4: Store user data and dispatch
      SessionHelper.setUserData(userData);

      dispatch({
        type: AUTH_USER,
        payload: userData,
      });
    } catch (error) {
      errorHandler(dispatch, error.response, AUTH_ERROR);
      throw error;
    }
  };
}

export function logout() {
  return function (dispatch) {
    SessionHelper.logout();
    dispatch({
      type: UNAUTH_USER,
    });
  };
}
